/* 🤖 this file was generated by script */
export const wiconLogOut01 = {
  name: 'log_out_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l5-5m0 0l-5-5m5 5H9m0-9H7.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C3 5.29 3 6.13 3 7.8v8.4c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33H9"/></svg>`,
};
